// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__m6Ouj","range":"Pagination_range__t5Vru","btn":"Pagination_btn__TwIYr","active":"Pagination_active__neJTS"};